import React, { useState } from "react";
import logo from "../assets/logo/logo.jpeg";
import { Book, Search } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import {
  Menu,
  UserRound,
  University,
  BookAIcon,
  Award,
  FileText,
  PhoneCall,
} from "lucide-react";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const MenuItem = [
    { path: "/login", label: "Login", icon: <UserRound /> },
    { path: "/", label: "University", icon: <University /> },
    { path: "/courses", label: "Courses", icon: <BookAIcon /> },
    { path: "/", label: "Scholarships", icon: <Award /> },
    { path: "/", label: "Articles", icon: <FileText /> },
    { path: "/", label: "Pathway Match", icon: <PhoneCall /> },
  ];

  return (
    <nav className="flex items-center justify-center fixed top-0 z-50 w-full shadow-lg bg-white h-20">
      <div className="w-full lg:w-[1024px] p-4 flex items-center justify-between">
        {/* <button
          onClick={() => setIsMenuOpen((v) => !v)}
          className="flex lg:hidden"
        >
          <Menu />
        </button> */}
        <Link to="https://scseducation.com/">
          <img src={logo} alt="" className="w-20 h-20" />
        </Link>
        <div className="hidden lg:flex gap-10 ">
          <Link to="/">University</Link>
          <Link to="/courses">Courses</Link>
          {/* <Link to="/">Scholarships</Link>
          <Link to="/">Articles</Link>
          <Link to="/">Pathway Match</Link>
          <Link to="/form">Form</Link> */}
          {/* <Link to="/career">Career</Link> */}
          <Link to="/top-universities">Local Universities</Link>
          <Link to="/top-overseas-universities">Overseas Universities</Link>
          {/* <Link to="/top-universities-cn">Local Uni CN</Link>
          <Link to="/top-overseas-universities-cn">Overseas Uni CN</Link> */}
          {/* Wordpress Link  */}
          {/* <Link to="https://scseducation.com/#about">About</Link>
          <Link to="https://scsedation.com/#services">Services</Link>
          <Link to="https://scseducation.com/#testimonial">Testimonial</Link>
          <Link to="https://scseducation.com/#faq">FAQ</Link>
          <Link to="https://scseducation.com/contact-us">Contact</Link> */}
        </div>
        <div className="flex items-center gap-4">
          {/* <Search />
          <Link to="/login" className="hidden lg:flex">
            Login
          </Link> */}
        </div>

        {/* <div
          className={`lg:hidden fixed top-20 z-50 inset-0 transition-opacity duration-300 ease-in-out
        ${
          isMenuOpen
            ? "bg-black/50 opacity-100"
            : "opacity-0 pointer-events-none"
        }`}
          onClick={() => setIsMenuOpen(false)}
        >
          <div
            className={`bg-white p-6 flex flex-col gap-6 text-lg transform transition-transform duration-300 ease-in-out
          w-full md:w-2/3 h-full
          ${isMenuOpen ? "translate-x-0" : "-translate-x-full"}`}
            onClick={(e) => e.stopPropagation()}
          >
            {MenuItem.map((item) => (
              <Link
                to={item.path}
                className={`flex gap-4 ${
                  location.pathname === item.path
                    ? "text-blue-500 font-semibold"
                    : ""
                }`}
              >
                {item.icon}
                {item.label}
              </Link>
            ))}
          </div>
        </div> */}
      </div>
    </nav>
  );
}
